var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionMasteryLevel5Background = function SvgCollectionMasteryLevel5Background(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 231,
    height: 199,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collection-mastery-level-5-background_svg__a)",
    d: "m130.171 91.734 100.464-58.003v116.005z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collection-mastery-level-5-background_svg__b)",
    d: "M100.463 91.733 0 149.735V33.731z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collection-mastery-level-5-background_svg__c)",
    d: "m114.276 108.152 52.135 89.909H62.142z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collection-mastery-level-5-background_svg__d)",
    d: "M114.276 89.909 62.142 0h104.269z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collection-mastery-level-5-background_svg__e)",
    d: "M122.59 57.34c3.092 1.488 5.796 3.339 8.632 5.273 5.263 3.442 10.257 4.1 16.397 4.557 2.133.242 2.133.242 4.096 1.227.115 4.388.184 8.777.245 13.167l.1 3.734c.125 11.95-3.185 19.869-10.162 29.37l-2.147 2.953c-5.793 6.724-16.154 16.744-25.171 18.155-4.11-.573-6.72-2.516-9.925-4.988l-1.839-1.376a427 427 0 0 1-5.094-3.915l-2.143-1.623c-8.498-6.809-16.324-17.036-18.472-27.912-.08-2.137-.106-4.276-.096-6.415l.01-3.73.025-3.884.013-3.93q.018-4.803.048-9.606c2.623-1.315 5.066-1.422 7.976-1.785 6.526-.978 11.178-2.823 16.627-6.457 6.59-4.165 13.334-5.312 20.88-2.815"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "collection-mastery-level-5-background_svg__a",
    x1: 130.171,
    x2: 264.122,
    y1: 91.734,
    y2: 91.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECD8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collection-mastery-level-5-background_svg__b",
    x1: 100.463,
    x2: -33.488,
    y1: 91.733,
    y2: 91.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECD8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collection-mastery-level-5-background_svg__c",
    x1: 114.276,
    x2: 114.276,
    y1: 228.031,
    y2: 108.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collection-mastery-level-5-background_svg__d",
    x1: 114.276,
    x2: 114.276,
    y1: -29.97,
    y2: 89.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collection-mastery-level-5-background_svg__e",
    x1: 114.536,
    x2: 114.536,
    y1: 56.031,
    y2: 135.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F3FE"
  })))));
};
export default SvgCollectionMasteryLevel5Background;